import React from "react";
import general from "../../../../../../general";
import CustomCardBase from "./CustomCardBase";

// subType=2 攻略
export default function StrategyMessage({ msg }) {
  const { attach } = msg;
  return (
    <CustomCardBase
      tagColor="#EB475F"
      tagText="攻略"
      title={attach?.news_title}
      gameInfo={attach?.game_info}
      desc={attach?.new_content}
      descClass="imc-line2"
      onClick={() => {
        general.game = attach?.game_info;
        general.history.push("/article/detail?id=" + attach?.news_id + "&type=raiders");
      }}
    />
  );
}
